import 'css/mobile/index.scss';

// import Splide from '@splidejs/splide';
import Swiper from 'swiper';
import 'js/mobile/common/common.jquery.js';

var swiper = new Swiper('.swiper-container', {
  slidesPerView: 'auto',
  spaceBetween: 16,
  freeMode: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});

// new Splide('#stories-slider', {
//   perPage: 0,
//   gap: '16px'
// }).mount();



